module.exports = __webpack_public_path__ + "static/media/coinbase_logo.3765bf16.jpeg";